function getUrlQuery(key) {
    const obj = {};
    const url = location.href;
    url.replace(/([^?=&#]+)=([^?=&#]+)/g, (str, key, value) => obj[key] = value);
    url.replace(/#([^?=&#]+)/g, (str, hash) => obj.HASH = hash);
    // 指定参数
    if (key) {
        return obj[key];
    }
    return obj;
}
export { getUrlQuery };
